// src/pages/GroceryCategories.jsx
import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import {
    collection,
    addDoc,
    updateDoc,
    deleteDoc,
    doc,
    getDocs,
} from "firebase/firestore";


const GroceryCategories = () => {
    const [categories, setCategories] = useState([]);
    const [name, setName] = useState("");
    const [imageUrl, setImageUrl] = useState("");
    const [editingId, setEditingId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        const snapshot = await getDocs(collection(db, "groceryCategories"));
        setCategories(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };

    const resetForm = () => {
        setName("");
        setImageUrl("");
        setEditingId(null);
        setError("");
    };

    const handleSave = async (e) => {
        e.preventDefault();
        if (!name || !imageUrl) {
            setError("All fields are required.");
            return;
        }

        setLoading(true);
        try {
            if (editingId) {
                await updateDoc(doc(db, "groceryCategories", editingId), { name, imageUrl });
            } else {
                const docRef = await addDoc(collection(db, "groceryCategories"), { name, imageUrl });
                await updateDoc(doc(db, "groceryCategories", docRef.id), { id: docRef.id });
            }
            resetForm();
            fetchCategories();
        } catch (err) {
            console.error(err);
            setError("Failed to save category.");
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (category) => {
        setName(category.name);
        setImageUrl(category.imageUrl);
        setEditingId(category.id);
    };

    const handleDelete = async (id) => {
        const confirmed = window.confirm("Are you sure you want to delete this category?");
        if (!confirmed) return;
        await deleteDoc(doc(db, "groceryCategories", id));
        fetchCategories();
    };

    return (
        <div className="p-6 bg-gray-50 min-h-screen">
            <div className="max-w-7xl mx-auto">
                <h1 className="text-3xl font-bold mb-6">Grocery Categories</h1>

                {error && <p className="text-red-600 mb-4">{error}</p>}

                <form onSubmit={handleSave} className="bg-white p-4 rounded shadow mb-6 space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <input
                            type="text"
                            placeholder="Category Name"
                            className="p-2 border rounded"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                        <input
                            type="text"
                            placeholder="Image URL"
                            className="p-2 border rounded"
                            value={imageUrl}
                            onChange={(e) => setImageUrl(e.target.value)}
                        />
                    </div>
                    {imageUrl && (
                        <img src={imageUrl} alt="Preview" className="h-24 w-24 object-cover rounded border mt-2" />
                    )}
                    <button
                        type="submit"
                        disabled={loading}
                        className="px-6 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                    >
                        {loading ? "Saving..." : editingId ? "Update Category" : "Add Category"}
                    </button>
                </form>

                <table className="w-full border rounded shadow bg-white">
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="border p-2">Image</th>
                            <th className="border p-2">Name</th>
                            <th className="border p-2">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {categories.length === 0 ? (
                            <tr>
                                <td colSpan="3" className="p-4 text-center">No categories found.</td>
                            </tr>
                        ) : (
                            categories.map(cat => (
                                <tr key={cat.id} className="border-b">
                                    <td className="p-2 text-center">
                                        <img src={cat.imageUrl} alt={cat.name} className="h-16 w-16 object-cover rounded mx-auto" />
                                    </td>
                                    <td className="p-2">{cat.name}</td>
                                    <td className="p-2 space-x-2">
                                        <button
                                            onClick={() => handleEdit(cat)}
                                            className="text-blue-600 hover:underline"
                                        >
                                            Edit
                                        </button>
                                        <button
                                            onClick={() => handleDelete(cat.id)}
                                            className="text-red-600 hover:underline"
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default GroceryCategories;
